export enum PlayType {
  '2Pt' = '2 Pt.',
  '2PtDefend' = '2 Pt. Defend',
  ExtraPt = 'Extra Pt.',
  ExtraPtBlock = 'Extra Pt. Block',
  FakeFG = 'Fake FG',
  FakePunt = 'Fake Punt',
  FG = 'FG',
  FGBlock = 'FG Block',
  KO = 'KO',
  KOREC = 'KO REC',
  OnsideKick = 'Onside Kick',
  OnsideKickRec = 'Onside Kick rec',
  Pass = 'Pass',
  Punt = 'Punt',
  PuntRec = 'Punt Rec',
  Run = 'Run',
  TeamLost = 'TeamLost',
  Missing = 'MissingPlayType',
}
